var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnowflake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.166 18.18l-1.665-1.494-1.665 1.494M12.501 18.948v-7.474M6.862 16.122l.611-2.038-2.276-.553M5.291 15.21l7.21-3.737M5.197 9.416l2.27-.548-.605-2.043M5.292 7.737l7.21 3.737M10.836 4.768l1.66 1.49 1.67-1.49M12.501 4v7.474M18.135 6.826l-.605 2.038 2.27.553M19.712 7.738l-7.21 3.737M19.8 13.531l-2.27.543.605 2.048M19.712 15.211l-7.21-3.737",
    stroke: "#222",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowflake);
export default __webpack_public_path__ + "static/media/snowflake.5e30e1c0.svg";
export { ForwardRef as ReactComponent };